module.exports = __webpack_public_path__ + "static/media/logo-icon.81356815.svg";